import { render } from "./CredenciamentoForm.vue?vue&type=template&id=adcfa34a"
import script from "./CredenciamentoForm.vue?vue&type=script&lang=js"
export * from "./CredenciamentoForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__